import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import Ranking from "../pages/ranking/page";
import Completed from "../pages/completed/page";
import Genre from "../pages/genre/page";
import ComicDetail from "../pages/comic/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "ranking", element: <Ranking /> },
      { path: "completed", element: <Completed /> },
      { path: "genre", element: <Genre /> },
      { path: "comic/:id", element: <ComicDetail /> },
      { path: "about", element: <About /> },
      { path: "faq", element: <Faq /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;